// extracted by mini-css-extract-plugin
export default {"store-badge__container":"styles_store-badge__container__QQ8HH"};